import React, { useEffect, useRef } from 'react';
import GarminConnectCard from './GarminConnectCard';
import { TRAINING_SOURCES, TRAINING_CONNECTIONS_ANCHOR, sourceVisible } from '../config/trainingSources';

// Profile "חיבורי אימונים" (2026-10-11): one section, one row per source, in the order of
// config/trainingSources.js. Each row keeps its existing logic — Garmin is the existing
// GarminConnectCard (hidden for non-eligible users). Strava removal C2 (2026-10-21): no Strava row.

const SCROLL_FLAG = 'ritmo_scroll_to';

/** Home -> Profile: ask Profile to scroll to this section once it renders (survives the page switch). */
export function requestTrainingConnectionsScroll() {
  try { sessionStorage.setItem(SCROLL_FLAG, TRAINING_CONNECTIONS_ANCHOR); } catch { /* storage blocked */ }
}

export default function TrainingConnectionsSection({ onGarminStatus }) {
  const ref = useRef(null);

  useEffect(() => {
    let wanted = null;
    try { wanted = sessionStorage.getItem(SCROLL_FLAG); } catch { /* storage blocked */ }
    if (wanted !== TRAINING_CONNECTIONS_ANCHOR) return;
    try { sessionStorage.removeItem(SCROLL_FLAG); } catch { /* ignore */ }
    const el = ref.current;
    if (el && typeof el.scrollIntoView === 'function') {
      requestAnimationFrame(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }));
    }
  }, []);

  const rows = {
    garmin: <GarminConnectCard key="garmin" onStatus={onGarminStatus} />,
  };

  return (
    <section id={TRAINING_CONNECTIONS_ANCHOR} ref={ref} dir="rtl" className="scroll-mt-20">
      <h3 className="text-[13px] font-semibold text-text-muted px-1">חיבורי אימונים</h3>
      <p className="mt-0.5 mb-2 px-1 text-[12px] text-text-muted">המקורות שמהם RitmoIQ מקבל את הפעילויות שלך.</p>
      <div className="rounded-card bg-surface border border-border overflow-hidden divide-y divide-divider">
        {TRAINING_SOURCES.filter((s) => rows[s.id] && sourceVisible(s, true))
          .map((s) => rows[s.id])}
        <div className="px-4 py-3.5 flex items-center gap-2 text-[14px] text-text-muted" aria-disabled="true">
          <span aria-hidden="true" className="text-[18px] leading-none">+</span>
          מקורות נוספים יתווספו בעתיד
        </div>
      </div>
    </section>
  );
}
